import { Link } from 'react-router-dom';
import { tvSeriesData } from '@/mocks/tvSeries';
import { useRef } from 'react';

export default function LatestUpdates() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const newSeries = tvSeriesData.filter(s => s.isNew);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 320;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新上线
            </h2>
            <p className="text-sm text-foreground-500 mt-2">刚刚更新的热门内容</p>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              className="w-10 h-10 rounded-full bg-background-100 border border-background-200 flex items-center justify-center text-foreground-600 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-left-s-line"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-10 h-10 rounded-full bg-background-100 border border-background-200 flex items-center justify-center text-foreground-600 hover:bg-background-200 transition-colors cursor-pointer"
            >
              <i className="ri-arrow-right-s-line"></i>
            </button>
            <Link
              to="/category/new"
              className="ml-2 flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              查看全部 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-4 md:gap-5 overflow-x-auto scrollbar-hide pb-4"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {newSeries.map((series) => (
            <Link
              key={series.id}
              to={`/article/${series.id}`}
              className="flex-none w-[200px] md:w-[220px] group cursor-pointer"
              data-product-shop
            >
              <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3">
                <img
                  src={series.posterImage}
                  alt={`${series.title} - 红桃影院最新上线`}
                  title={`${series.title} ${series.category}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute top-2 right-2">
                  <span className="px-2 py-0.5 bg-accent-500 text-white text-xs font-medium rounded-md">
                    NEW
                  </span>
                </div>
                <div className="absolute bottom-2 left-2 right-2">
                  <span className="text-white text-xs bg-black/50 px-2 py-0.5 rounded">
                    {series.updateInfo}
                  </span>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
                {series.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{series.englishTitle}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}